module.exports = __webpack_public_path__ + "img/gruppen_diagnose_05.0424223c.png";